import { Star } from "lucide-react";

// Display-only star bar. rating can be fractional (e.g. 4.3)
export const StarRating = ({ rating = 0, size = 16, className = "", testId }) => {
  return (
    <div className={`flex items-center gap-0.5 ${className}`} data-testid={testId}>
      {[1, 2, 3, 4, 5].map((i) => {
        const fill = Math.max(0, Math.min(1, rating - (i - 1)));
        return (
          <span key={i} className="relative inline-block" style={{ width: size, height: size }}>
            <Star size={size} className="absolute inset-0 text-white/15" strokeWidth={1.5} />
            <span className="absolute inset-0 overflow-hidden" style={{ width: `${fill * 100}%` }}>
              <Star size={size} className="text-[#3377ff]" fill="#0055ff" strokeWidth={1.5} />
            </span>
          </span>
        );
      })}
    </div>
  );
};

// Interactive star selector for the review form
export const StarSelect = ({ value, onChange, size = 30 }) => {
  return (
    <div className="flex items-center gap-1.5" data-testid="star-select">
      {[1, 2, 3, 4, 5].map((i) => (
        <button
          key={i}
          type="button"
          data-testid={`star-select-${i}`}
          onClick={() => onChange(i)}
          className="transition-transform duration-200 hover:scale-125"
          aria-label={`${i} star`}
        >
          <Star
            size={size}
            className={i <= value ? "text-[#3377ff]" : "text-white/20"}
            fill={i <= value ? "#0055ff" : "transparent"}
            strokeWidth={1.5}
          />
        </button>
      ))}
    </div>
  );
};
